import { FC, PropsWithChildren } from "react";
import classes from './lessonItem.module.scss'
import { IAdminLesson } from "../../model/types";
import { formatUtcToMsk } from "../../../../shared/lib/helpers/formatUtcToMsk";
import { Link } from "react-router-dom";

interface IProps {
    lesson: IAdminLesson;
}

export const AdminLessonItem: FC<IProps & PropsWithChildren> = ({lesson, children}) => {

    return (
        <tr 
            className={classes.item}
        >
            <td>
                {formatUtcToMsk(lesson.created_at)} (мск)
            </td>  
            <td>
                {lesson.tutor_name}
            </td>
            <td>
                <Link to={'/students/' + lesson.student_id}>{lesson.student_name}</Link>
            </td>
            <td>
                {lesson.duration_in_minutes}
            </td>
            <td className={classes.features}>
                {children}
            </td>
        </tr>
    )
}
